import ChallengeTour from './ChallengeTour';
export default ChallengeTour;
